import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import { config } from '../../providers/config';
import { Response } from '@angular/http';
import 'rxjs/add/operator/map';
import { HttpService } from '../services/http.service';
import { LoaderService } from './loader.service';
import { error } from 'selenium-webdriver';

@Injectable()
export class HomeService {
  quotesUrl = '/api/v1/quotes/';
  postsUrl = '/api/v1/posts/';
  userUrl = '/api/v1/users/';
  currentPathUrl = '/api/v1/users/';
  meditationUrl = '/api/v1/meditations/settings/';
  meditationAudioUrl = '/api/v1/meditations/audio/';
 // sendBhiFeedback = '/api/v1/feedback/'
  httpOptions:object={};
  constructor(private http:HttpClient, private httpService:HttpService,private loaderService: LoaderService) { 
    
  }
 
  //Get quotes.
  getQuotes() {
    return this.httpService.get(this.quotesUrl).map((res:Response) => {
      return res.json();
    })
  }


  //Get posts.
  getPosts() {
    return this.httpService.get(this.postsUrl).map((res:Response) => {
      return res.json();
    })
  }

  //Get Current path details of the user
  currentPath() {
    return this.httpService.get(this.getFullUrlWithUserId(this.userUrl,'/paths/current/')).map((res:Response) => {
      return res.json();
    })
  }

  //Get My path details of the user
  myPaths() {
    return this.httpService.get(this.getFullUrlWithUserId(this.currentPathUrl,'/paths/my/')).map((res:Response) => {
      return res.json();
    })
  }

  //Get Explore paths details of the user
  explorePaths() {
    return this.httpService.get(this.getFullUrlWithUserId(this.currentPathUrl,'/paths/')).map((res:Response) => {
      return res.json();
    })
  }

  //Get single path details of the user
  eachPathDetails(id) {
    return this.httpService.get(this.getFullUrlWithUserId(this.currentPathUrl,`/paths/${id}/`)).map((res:Response) => {
      return res.json();
    })
  }

  //Get single exercise details of the user
  eachExerciseDetails(id) {
    return this.httpService.get(this.getFullUrlWithUserId(this.currentPathUrl,`/exercises/${id}/`)).map((res:Response) => {
      return res.json();
    })
  }

  //Update exercise
  updateExerciseDetails(data,id) {
    return this.httpService.put(this.getFullUrlWithUserId(this.currentPathUrl,`/exercises/${id}/`),data).map((res:Response) => {
      return res.json();
    })
  }

  //Update path details of the user
  updatePathDetails(id) {
    return this.httpService.put(this.getFullUrlWithUserId(this.currentPathUrl,`/paths/${id}/`), null).map((res:Response) => {
      return res.json();
    })
  }

  //Get path details based on path id and its exercises
  getPathDetails(id) {
    return this.httpService.get(this.getFullUrlWithUserId(this.currentPathUrl,`/paths/${id}/exercises/`)).map((res:Response) => {
      return res.json();
    })
  }

  //Get Meditation settings
  meditationSettings() {
    return this.httpService.get(this.meditationUrl).map((res:Response) => {
      return res.json();
    })
  }
  
  //Get audio details of Meditation.
  meditationAudioDetails(number) {
    return this.http.get(this.getFullUrl(this.meditationAudioUrl+`${number}/`),this.getHeader()).map((res) => {
      return res;
    })
  }

  //Get audio details of Meditation.
  updateMeditationInfo(number,obj) {
    return this.httpService.put((this.getFullUrlWithUserId(this.currentPathUrl,`/meditations/${number}/`)),obj).map((res) => {
      return res;
    })
  }

  //Send the Feedback.
  saveFeedback(type,id,obj) {
    return this.http.post((this.getFeedbackUrl(this.currentPathUrl,`/${type}/${id}/feedback/`)),obj,this.getHeader()).map((res) => {
      return res;
    })
  }

  //To get the the http headers.
  public getHeader() {
    let token = localStorage.getItem('token');
    this.httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json', 'authorization': `JWT ${token}` })
    };
    return this.httpOptions;
  }

  // To get the full api url and userid in the url
  public getFullUrlWithUserId(url: string, extUrl:string): string {
    let userId = localStorage.getItem('user_id');
    return url+userId+extUrl;
  }

  // To get the full api url and userid in the url using http
  public getFeedbackUrl(url: string, extUrl:string): string {
    let userId = localStorage.getItem('user_id');
    return config.api_url+url+userId+extUrl;
  }

   //To get the full api url
   public getFullUrl(url: string): string {
    return config.api_url + url;
  }
  
/*
  // send BHI feedback

  sendFeedback(uuid,obj){
    this.loaderService.show();
    return this.http.put((config.api_url+this.sendBhiFeedback+"bhi/"+uuid),obj).map((res) => {
      return res;
    })
  }
  */

}




// WEBPACK FOOTER //
// /Volumes/Projects/WellBrain_Azure_Web/src/app/services/home.service.ts